import { useLayoutEffect } from 'react'

import { dismissBootLoader } from '../../lib/bootLoader'

export function BootLoaderHandoff() {
  useLayoutEffect(() => {
    dismissBootLoader()
  }, [])

  return null
}
